import { SubMenuAccountListItem } from '../SubMenuAccountListItem'

import * as styles from './SubMenuAccountList.module.css'

function SubMenuAccountList(props) {
  const {
    activeKey,
    className = styles.SubMenuAccountList,
    countKey,
    isNeedReconnect,
    items,
    selected,
    selectedKey,
    titleKey,
  } = props

  return (
    <div className={className}>
      {items?.map(i => (
        <SubMenuAccountListItem
          count={i[countKey]}
          isActive={i[activeKey]}
          item={i}
          key={i[selectedKey]}
          reconnect={isNeedReconnect(i)}
          selected={selected?.[selectedKey] === i[selectedKey]}
          onClick={props.onClick}
          onReconnect={props.onReconnect}
        >
          {i[titleKey]}
        </SubMenuAccountListItem>
      ))}
    </div>
  )
}

export default SubMenuAccountList
